import api from '../utils/api';
import { getErrorResponse } from '../utils/apiErrorHandler';

/* eslint-disable import/prefer-default-export */

export const getAllGuestQuests = action$ =>
  action$.ofType('GET_GUEST_QUESTS')
    .mergeMap(action =>
      api.getGuestQuests()
        .map(response => ({ type: 'GET_OPTIMIZED_ALL_QUESTS_SUCCESS', payload: response }))
        .takeUntil(action$.ofType('GET_OPTIMIZED_ALL_QUESTS_ABORTED'))
        .defaultIfEmpty({ type: 'GET_OPTIMIZED_ALL_QUESTS_CANCELED' })
        .catch(error => getErrorResponse({ type: 'GET_OPTIMIZED_ALL_QUESTS_ERROR', error }))
        .startWith({ type: 'GET_OPTIMIZED_ALL_QUESTS_PENDING', payload: action.payload }));

export const getOptimizedAllQuests = action$ =>
  action$.ofType('GET_OPTIMIZED_ALL_QUESTS')
    .mergeMap(action =>
      api.getOptimizedQuests(action.payload.filterType, action.payload.page, action.payload.token)
        .map(response => ({ type: 'GET_OPTIMIZED_ALL_QUESTS_SUCCESS', payload: response }))
        .takeUntil(action$.ofType('GET_OPTIMIZED_ALL_QUESTS_ABORTED'))
        .defaultIfEmpty({ type: 'GET_OPTIMIZED_ALL_QUESTS_CANCELED' })
        .catch(error => getErrorResponse({ type: 'GET_OPTIMIZED_ALL_QUESTS_ERROR', error }))
        .startWith({ type: 'GET_OPTIMIZED_ALL_QUESTS_PENDING', payload: action.payload }));

export const getOptimizedEndedQuests = action$ =>
  action$.ofType('GET_OPTIMIZED_ENDED_QUESTS')
    .mergeMap(action =>
      api.getOptimizedQuests(action.payload.filterType, action.payload.page, action.payload.token)
        .map(response => ({ type: 'GET_OPTIMIZED_ENDED_QUESTS_SUCCESS', payload: response }))
        .takeUntil(action$.ofType('GET_OPTIMIZED_ENDED_QUESTS_ABORTED'))
        .defaultIfEmpty({ type: 'GET_OPTIMIZED_ENDED_QUESTS_CANCELED' })
        .catch(error => getErrorResponse({ type: 'GET_OPTIMIZED_ENDED_QUESTS_ERROR', error }))
        .startWith({ type: 'GET_OPTIMIZED_ENDED_QUESTS_PENDING', payload: action.payload }));

export const getSearchLightGames = action$ =>
  action$.ofType('GET_SEARCHLIGHT_GAMES')
    .mergeMap(action =>
      api.getSearchLightGames(action.payload.token)
        .map(response => ({ type: 'GET_SEARCHLIGHT_GAMES_SUCCESS', payload: response }))
        .takeUntil(action$.ofType('GET_SEARCHLIGHT_GAMES_ABORTED'))
        .defaultIfEmpty({ type: 'GET_SEARCHLIGHT_GAMES_CANCELED' })
        .catch(error => getErrorResponse({ type: 'GET_SEARCHLIGHT_GAMES_ERROR', error }))
        .startWith({ type: 'GET_SEARCHLIGHT_GAMES_PENDING', payload: action.payload }));

export const getSearchLightGameInfo = action$ =>
  action$.ofType('GET_SEARCHLIGHT_GAME_INFO')
    .mergeMap(action =>
      api.getGameGuestLikes(action.payload.gameId)
        .map(response => ({ type: 'GET_SEARCHLIGHT_GAME_INFO_SUCCESS', payload: response }))
        .takeUntil(action$.ofType('GET_SEARCHLIGHT_GAME_INFO_ABORTED'))
        .defaultIfEmpty({ type: 'GET_SEARCHLIGHT_GAME_INFO_CANCELED' })
        .catch(error => getErrorResponse({ type: 'GET_SEARCHLIGHT_GAME_INFO_ERROR', error }))
        .startWith({ type: 'GET_SEARCHLIGHT_GAME_INFO_PENDING', payload: action.payload }));

export const likeSearchLightGame = action$ =>
  action$.ofType('LIKE_SEARCHLIGHT_GAME')
    .mergeMap(action =>
      api.likeGame(action.payload.gameId, action.payload.token)
        .map(response => ({ type: 'LIKE_SEARCHLIGHT_GAME_SUCCESS', payload: { ...response, ...action.payload } }))
        .takeUntil(action$.ofType('LIKE_SEARCHLIGHT_GAME_ABORTED'))
        .defaultIfEmpty({ type: 'LIKE_SEARCHLIGHT_GAME_CANCELED' })
        .catch(error => getErrorResponse({ type: 'LIKE_SEARCHLIGHT_GAME_ERROR', error }))
        .startWith({ type: 'LIKE_SEARCHLIGHT_GAME_PENDING', payload: action.payload }));

export const unlikeSearchLightGame = action$ =>
  action$.ofType('UNLIKE_SEARCHLIGHT_GAME')
    .mergeMap(action =>
      api.unlikeGame(action.payload.gameId, action.payload.token)
        .map(response => ({ type: 'UNLIKE_SEARCHLIGHT_GAME_SUCCESS', payload: { ...response, ...action.payload } }))
        .takeUntil(action$.ofType('UNLIKE_SEARCHLIGHT_GAME_ABORTED'))
        .defaultIfEmpty({ type: 'UNLIKE_SEARCHLIGHT_GAME_CANCELED' })
        .catch(error => getErrorResponse({ type: 'UNLIKE_SEARCHLIGHT_GAME_ERROR', error }))
        .startWith({ type: 'UNLIKE_SEARCHLIGHT_GAME_PENDING', payload: action.payload }));
